module.exports = __webpack_public_path__ + "img/lightning-dice.af00ab6.webp";